import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { FiChevronsRight } from "react-icons/fi";

export default function Paginate({ handlePagination, data = "" }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-between gap-5 py-3">
      <ReactPaginate
        nextLabel={<FiChevronsRight className={"rtl:rotate-180"} />}
        previousLabel={<FiChevronsRight className={"ltr:rotate-180"} />}
        className="flex items-center gap-1 py-0 md:gap-2 md:p-4"
        pageRangeDisplayed={2}
        marginPagesDisplayed={2}
        breakLinkClassName="text-primary"
        activeLinkClassName="!bg-primary !bg-none !text-white"
        pageLinkClassName="grid mainLinear text-primary place-items-center !min-w-0 rounded-[3px] !size-[25px] duration-300 border-none text-center hover:bg-blue-950  md:min-w-[2.5rem]"
        previousLinkClassName="grid mainLinear text-primary place-items-center  text-black !min-w-0 rounded-[3px] !size-[25px] duration-300 text-center hover:bg-blue-950 "
        disabledLinkClassName="opacity-50 text-white !bg-[#24365F]"
        nextLinkClassName="grid mainLinear text-primary place-items-center  text-black !min-w-0 rounded-[3px] !size-[25px] duration-300 text-center hover:bg-blue-950 "
        pageCount={data?.last_page || 1}
        onPageChange={({ selected }) =>
          handlePagination ? handlePagination(selected + 1) : null
        }
        // forcePage={data?.current_page - 1}
      />
      {data?.from && (
        <p className="text-sm text-black ">
          {`${t("Showing")} ${data?.from} ${t("to")} ${data?.to} ${t("of")} ${
            data?.total
          } ${t("entries")}`}
        </p>
      )}
    </div>
  );
}
